import { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import doneIllustration from "../../../static/illustration--done.svg";
import rtHeadshot from "../../../static/rt-headshot.jpg";
import { useAnswer } from "../../../util/form";
import { useAppStore } from "../../../store/store";
import useGetApi from "../../../util/useGetApi";

export default function DoneScreen({ updateValidation, screen }) {
  const { user } = useAppStore();
  const { logout } = useGetApi();
  const navigate = useNavigate();
  // We don't need to set an answer in this screen as it would overwrite the portfolio selection
  // from previous screens, but we keep the hook for consistency
  useAnswer(screen.id);

  useEffect(() => {
    updateAnswer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function updateAnswer() {
    // Don't set a new answer here - this would overwrite the portfolio selection from screen 3.14
    // Just update validation to allow continuing
    updateValidation(true);
  }

  async function handleSignOut() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <motion.div
      className="w-full h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <section className="w-full h-full px-6 py-16 text-center bg-white md:px-10 lg:px-16 lg:py-24">
        <div className="relative w-full h-full max-w-4xl pt-24 pb-16 mx-auto border wrapper border-as-green-100 md:pt-32 md:pb-24">
          <div className="absolute left-1/2 top-0 flex h-[111px] md:h-[163px] w-40 md:w-[254px] -translate-x-1/2 -translate-y-1/4 items-center justify-center bg-white">
            <img
              className="block h-auto w-32 md:w-[188px] mx-auto"
              src={doneIllustration}
              alt=""
            />
          </div>
          <div className="w-full max-w-2xl mx-auto">
            <h1 className="mb-4 mt-3 text-3xl !leading-tight md:mb-6 md:mt-5 md:text-5xl">
              Welcome to the
              <span className="text-teal-700">
                {" "}
                Artesys family, {user.fname}.
              </span>
            </h1>
            <p className="max-w-full mx-auto w-80">
              We look forward to working with you to help you reach retirement
              goals!
            </p>
            <div className="flex items-center justify-center mt-6 text-lg leading-tight md:mt-8">
              <img
                className="block w-16 h-auto rounded-full shrink-0 aspect-square md:w-[72px]"
                src={rtHeadshot}
                alt=""
              />
              <div className="ml-3 text-left md:ml-5">
                <p className="!mb-0 font-bold text-gray-800">
                  R.&#8202;T. Jones, Jr.
                </p>
                <p className="text-gray-800">President</p>
              </div>
            </div>
            <div className="flex justify-center mt-8 md:mt-12">
              <button
                type="button"
                className="btn border border-red-300 bg-white text-red-600 hover:border-red-600 hover:bg-red-50 hover:text-red-700 focus-visible:border-red-600 focus-visible:text-red-700 active:border-red-700 active:text-red-700"
                onClick={handleSignOut}
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
